<template>
    <div class="sa-flexbox" style="padding-bottom: 20px">
        <div class="sa-flexbox-header">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-if="!isPazienteMenu">
                        <label for="">Cognome:</label>
                        <b-form-input v-model="filtroRiepilogoAccessoAdi.cognome" type="search" placeholder="Cognome"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-if="!isPazienteMenu">
                        <label>Nome:</label>
                        <b-form-input v-model="filtroRiepilogoAccessoAdi.nome" type="search" placeholder="Nome"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-if="!isPazienteMenu">
                        <label>Codice identificativo:</label>
                        <b-form-input v-model="filtroRiepilogoAccessoAdi.identificativo" type="search" placeholder="Identificativo"></b-form-input>
                    </b-col>

                    <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Data inizio:</label>
                        <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="filtroRiepilogoAccessoAdi.dataOraInizio" type="date" placeholder="Inserisci Data"></date-picker>
                    </b-col>
                    <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Data fine:</label>
                        <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="filtroRiepilogoAccessoAdi.dataOraFine" type="date" placeholder="Inserisci Data"></date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="mt-1">Stato:</label>
                        <b-form-select v-model="filtroRiepilogoAccessoAdi.stato" value-field="value" text-field="descrizione" value="''" :options="riepilogoAccessiStatoOptions" class="mt-1"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label>Cognome Operatore:</label>
                        <b-form-input v-model="filtroRiepilogoAccessoAdi.cognomeOperatore" type="search" placeholder="Cognome operatore"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label>Nome Operatore:</label>
                        <b-form-input v-model="filtroRiepilogoAccessoAdi.nomeOperatore" type="search" placeholder="Nome operatore "></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label>Profilo Operatore:</label>
                        <b-form-input v-model="filtroRiepilogoAccessoAdi.profilo" type="search" placeholder="Profilo"></b-form-input>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <div class="sa-flexbox-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="visibleFields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(nominativo)="{ item }">
                        <span>
                            <b>{{ item.cognome }} {{ item.nome }}</b></span
                        >
                        <br />
                        <span>{{ item.identificativo }} </span>
                    </template>
                    <template v-slot:cell(dataOraInizio)="{ item }">
                        <span>{{ formatDateTime(item.dataOraInizio) }}</span>
                    </template>
                    <template v-slot:cell(dataOraFine)="{ item }">
                        <span>{{ formatDateTime(item.dataOraFine) }}</span>
                    </template>

                    <template v-slot:cell(operatoreNomeCognome)="{ item }">
                        <span>{{ item.cognomeOperatore }} {{ item.nomeOperatore }} </span>
                        <br />
                        <span> {{ item.profilo }}</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button size="sm" v-b-tooltip.hover title="Info" variant="outline-secondary" @click="onClickVisualizzaAttivita(row)" :disabled="row.item.numeroPrestazioni === 0">
                                <font-awesome-icon icon="info-circle"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                    <template #row-details>
                        <div class="sa-table-row-details">
                            <b-table sticky-header stacked="lg" striped hover :items="itemsAttivita" :fields="fieldsAttivita" sort-icon-left head-variant="light" class="sa-b-table">
                                <template v-slot:cell(indicazioni)="{ item }">
                                    <span v-html="item.indicazioni"> </span>
                                </template>
                                <template v-slot:cell(dataOraPrevista)="{ item }">
                                    <span>{{ formatDateTime(item.dataOraPrevista) }}</span>
                                </template>
                                <template v-slot:cell(dataOraEffettuata)="{ item }">
                                    <span>{{ formatDateTime(item.dataOraEffettuata) }}</span>
                                </template>
                            </b-table>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-flexbox-footer" style="background-color: ciano">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {
        idAccettazione: { type: String, default: null },
    },
    mixins: [UtilityMixin],
    components: {
        DatePicker,
    },
    computed: {
        visibleFields() {
            return this.fields.filter((field) => field.visible);
        },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            isPazienteMenu: false,
            rigaAttualeAperta: null,
            filtroRiepilogoAccessoAdi: { cognome: null, nome: null, stato: null, dataOraInizio: null, dataOraFine: null, identificativo: null, nomeOperatore: null, cognomeOperatore: null, profilo: null },
            items: [],
            riepilogoAccessiStatoOptions: [
                { value: null, descrizione: "-Seleziona Valore-" },
                { value: "APERTO", descrizione: "APERTO" },
                { value: "CHIUSO", descrizione: "CHIUSO" },
            ],
            listKey: 0,
            pathResource: "/rsaadiaccessi/riepilogo",
            pathResourceAdiAccessi: "/rsaattivitapazienti",
            rigaSelezionata: {},
            fields: [
                {
                    label: "Cognome/Nome",
                    key: "nominativo",
                    sortable: false,
                    visible: !this.isPazienteMenu,
                },
                {
                    label: "Data/ora Inizio",
                    key: "dataOraInizio",
                    sortable: true,
                    visible: true,
                },
                {
                    label: "Data/ora Fine",
                    key: "dataOraFine",
                    sortable: true,
                    visible: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: false,
                    visible: true,
                },

                {
                    label: "Operatore",
                    key: "operatoreNomeCognome",
                    sortable: false,

                    visible: true,
                },
                {
                    label: "N. Attività",
                    key: "numeroPrestazioni",
                    sortable: false,
                    visible: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", visible: true },
            ],
            itemsAttivita: [],
            fieldsAttivita: [
                {
                    label: "Indicazioni",
                    key: "indicazioni",
                },
                {
                    label: "Note",
                    key: "note",
                },

                { label: "Stato", key: "stato" },
                {
                    label: "Data/Ora prevista",
                    key: "dataOraPrevista",
                },
                {
                    label: "Data/ora effettuata",
                    key: "dataOraEffettuata",
                },
            ],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroRiepilogoAccessoAdi"]) {
            me.filtroRiepilogoAccessoAdi = JSON.parse(sessionStorage["filtroRiepilogoAccessoAdi"]);
        } else {
            sessionStorage["filtroRiepilogoAccessoAdi"] = JSON.stringify(me.filtroRiepilogoAccessoAdi);
        }
    },
    watch: {
        currentPage() {
            let me = this;
            me.init();
        },
    },
    methods: {
        init(isPazienteMenu) {
            let me = this;
            me.isPazienteMenu = isPazienteMenu;
            me.fields[0].visible = !isPazienteMenu;
            me.loadData();
        },
        setPazienteMenu(isPaziente) {
            let me = this;
            me.isPazienteMenu = isPaziente;
        },
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoAccessoAdi"] = JSON.stringify(me.filtroRiepilogoAccessoAdi);
            if (me.idAccettazione) {
                let filtro = me.filtroRiepilogoAccessoAdi;
                filtro.idAccettazione = me.idAccettazione;
                filtro.cognome = null;
                filtro.nome = null;
                filtro.identificativo = null;
                UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
            }
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroRiepilogoAccessoAdi, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
            me.showModalLoading = false;
        },
        loadDataError(error) {
            let me = this;
            me.showModalLoading = false;
            console.log("errore response", error);
        },
        onReset() {
            let me = this;
            me.filtroRiepilogoAccessoAdi = { cognome: null, nome: null, stato: null, dataOraInizio: null, dataOraFine: null, identificativo: null, nomeOperatore: null, cognomeOperatore: null, profilo: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoAccessoAdi"] = JSON.stringify(me.filtroRiepilogoAccessoAdi);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoAccessoAdi"] = JSON.stringify(me.filtroRiepilogoAccessoAdi);
            me.loadData();
        },
        onClickVisualizzaAttivita(row) {
            let me = this;
            if (me.rigaAttualeAperta && me.rigaAttualeAperta.item.id === row.item.id) {
                row.toggleDetails();
                me.rigaAttualeAperta = null;
                return;
            }
            if (me.rigaAttualeAperta) {
                me.rigaAttualeAperta.toggleDetails();
            }

            me.loadAttivita(row);
            row.toggleDetails();
            me.rigaAttualeAperta = row;
        },
        loadAttivita(row) {
            let me = this;
            me.itemsAttivita = [];
            me.rigaSelezionata = row.item;
            UtilityMixin.methods.loadDataResources(me.pathResourceAdiAccessi, { idAccesso: row.item.id }, me.loadAttivitaSuccess, me.loadAttivitaError);
        },
        loadAttivitaSuccess(response) {
            let me = this;
            me.itemsAttivita = response.data.data.list;
        },
        loadAttivitaError(response) {
            console.log("errore response", response);
        },
    },
};
</script>
